import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useMethodLayerCounts(projectId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['method-layer-counts', projectId],
    enabled: !!projectId && enabled,
    /** Popup chỉ mở theo yêu cầu → luôn fetch lại. staleTime > 0 làm badge
        "N mặt bằng" và khoá tick đứng yên sau khi xoá mặt bằng (phải F5 mới đúng). */
    staleTime: 0,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<Map<string, number>> => {
      const { data, error } = await (supabase as any)
        .from('method_layers')
        .select('milestone_id')
        .eq('project_id', projectId).eq('is_active', true);
      if (error) throw error;
      const counts = new Map<string, number>();
      for (const row of (data || []) as Array<{ milestone_id: string | null }>) {
        if (!row.milestone_id) continue;
        counts.set(row.milestone_id, (counts.get(row.milestone_id) ?? 0) + 1);
      }
      return counts;
    },
  });
}
